// extracted by mini-css-extract-plugin
module.exports = {"main":"GlU4n","section":"__61PEw","first":"OS5QX","icons-bar":"mmZOU","box":"nSTsO","services":"kuRMB"};